<template>
  <div>
    <svg ref="chart"></svg>
  </div>
</template>

<script>
  /* eslint-disable */
  import d3 from 'd3'
  import nv from 'nvd3'
  import $ from 'jquery'
  
  export default{
    props:{
      options: {
        type: Object,
        required: true
      },
      data: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        default: {
          options:{
          },
          xAxis: {
            // x轴的label
            axisLabel: '',
            // x轴取值范围 [0,100]
            domain: null,
            fontSize: '12px',
            duration: '500',
            // x轴label 旋转度数
            rotateLabels: 0,
            // x轴显示最大最小label
            showMaxMin: false,
            ticks: null,
            tickValues: null
          },
          yAxis: {
            // y轴的label
            axisLabel: '',
            // y轴取值范围 [0,100]
            domain: null,
            fontSize: '12px',
            // y轴label 旋转度数
            rotateYLabel: 0,
            // y轴显示最大最小label
            showMaxMin: false,
            tickFormat: (d) => {
              return d3.format(',.2f')(d)
            },
            ticks: null,
            tickValues: null
          }
        },
        chart: null
      }
    },
    mounted () {
      this.setChartOptions()
    },
    methods: {
      setChartOptions () {
        const xAxis = Object.clone(this.options['chart']['xAxis'])
        const yAxis = Object.clone(this.options['chart']['yAxis'])
        const tooltip = Object.clone(this.options['chart']['tooltip'])
        const options = Object.clone(this.options['chart'])
        delete options.xAxis
        delete options.yAxis
        delete options.tooltip
        const chartOptions = {
          options: Object.assign({}, this.default.options, options),
          tooltip: Object.assign({}, this.default.tooltip, tooltip),
          xAxis: Object.assign({}, this.default.xAxis, xAxis),
          yAxis: Object.assign({}, this.default.yAxis, yAxis)
        }
        
        const chart = nv.models.multiBarHorizontalChart()
          .options(Object.assign({},{
            duration: 300
          }, chartOptions.options))
        chart.height(chartOptions.options.height)
        $(this.$refs.chart).height(chartOptions.options.height)

        Object.forEach(chartOptions.tooltip, (val, key) => {
          if (val) {
            chart.tooltip[key].call(this, val)
          }
        })
        Object.forEach(chartOptions.xAxis, (val, key) => {
          if (val) {
            chart.xAxis[key].call(this, val)
          }
        })
        Object.forEach(chartOptions.yAxis, (val, key) => {
          if (val) {
            chart.yAxis[key].call(this,val)
          }
        })
  
        this.drawChart(chart, chartOptions.options.height)
        this.chart = chart
        return chart
      },
      drawChart (chart) {
        d3.select(this.$refs.chart)
          .datum(this.data)
          .transition()
          .duration(500)
          .call(chart)
        nv.utils.windowResize(chart.update);
      }
    },
    watch: {
      data: {
        handler: function () {
          if (this.chart) {
            this.drawChart(this.chart)
          }
        }
      },
      options: {
        handler: function (newVal) {
          if (this.chart) {
            this.setChartOptions()
            this.drawChart(this.chart)
          }
        },
        deep: true
      }
    }
  }
</script>

<style lang='scss' scoped rel="stylesheet/scss">
</style>



// WEBPACK FOOTER //
// nvd3-bar-chart.vue?4e929d68